var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongratsAssistantRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1311.13 697.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .congrats-img-cls-1{fill:#ebebeb;}.congrats-img-cls-2{fill:#202b30;}.congrats-img-cls-3{fill:#36bdb9;}.congrats-img-cls-10,.congrats-img-cls-4{fill:#fff;}.congrats-img-cls-4{opacity:0.4;}.congrats-img-cls-5{fill:#25aaaa;}.congrats-img-cls-6,.congrats-img-cls-7{fill:#010101;}.congrats-img-cls-6{opacity:0.2;}.congrats-img-cls-7,.congrats-img-cls-9{opacity:0.1;}.congrats-img-cls-8{fill:#f7b319;}.congrats-img-cls-29,.congrats-img-cls-9{fill:none;}.congrats-img-cls-9{stroke:#010101;stroke-miterlimit:10;stroke-width:7px;}.congrats-img-cls-11{fill:#f7ed4d;}.congrats-img-cls-12{fill:#29996a;}.congrats-img-cls-13{fill:#fce353;}.congrats-img-cls-14{fill:#31a59f;}.congrats-img-cls-15{fill:url(#linear-gradient);}.congrats-img-cls-16{fill:url(#linear-gradient-2);}.congrats-img-cls-17{fill:url(#linear-gradient-3);}.congrats-img-cls-18{fill:url(#linear-gradient-4);}.congrats-img-cls-19{fill:url(#linear-gradient-5);}.congrats-img-cls-20{fill:url(#linear-gradient-6);}.congrats-img-cls-21{fill:url(#linear-gradient-7);}.congrats-img-cls-22{fill:url(#linear-gradient-8);}.congrats-img-cls-23{fill:url(#linear-gradient-9);}.congrats-img-cls-24{fill:url(#linear-gradient-10);}.congrats-img-cls-25{fill:url(#linear-gradient-11);}.congrats-img-cls-26{fill:url(#linear-gradient-12);}.congrats-img-cls-27{fill:url(#linear-gradient-13);}.congrats-img-cls-28{fill:url(#linear-gradient-14);}.congrats-img-cls-30{fill:url(#linear-gradient-15);}.congrats-img-cls-31{fill:url(#linear-gradient-16);}.congrats-img-cls-32{fill:url(#linear-gradient-17);}.congrats-img-cls-33{fill:url(#linear-gradient-18);}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1031.5,
    y1: 2670.94,
    x2: 1044.71,
    y2: 2672.95,
    gradientTransform: "translate(-27.76 -729.46) rotate(-25.09) scale(0.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64c18a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4cb47b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0f9253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008a4a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 339.22,
    y1: 2282.21,
    x2: 337.89,
    y2: 2295.12,
    gradientTransform: "matrix(0.65, -0.44, 0.44, 0.65, 154.74, -863.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6086c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#506eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465fac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3198.03,
    y1: -1113.2,
    x2: -3200.63,
    y2: -1125.59,
    gradientTransform: "translate(-1446.37 -2681.09) rotate(-148.8) scale(1.27)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1948.26,
    y1: 2121.42,
    x2: 1961.17,
    y2: 2123.38,
    gradientTransform: "translate(-141.96 -490.49) rotate(-9.85) scale(0.68)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 167.22,
    y1: 1014.09,
    x2: 164.99,
    y2: 997.17,
    gradientTransform: "translate(764.31 -464.08) rotate(-23.56) scale(1.24)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3085.45,
    y1: 111.34,
    x2: -3083.3,
    y2: 124.1,
    gradientTransform: "matrix(-0.65, -1.07, 1.07, -0.65, -584.16, -2711.28)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -958.05,
    y1: -3088.39,
    x2: -958.05,
    y2: -3077.04,
    gradientTransform: "translate(-2643.66 -441.48) rotate(121.41) scale(1.35)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1599.97,
    y1: -4431.82,
    x2: -1602.19,
    y2: -4448.73,
    gradientTransform: "translate(-1952.39 -911.62) rotate(134.62) scale(0.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8961d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fcd219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feea17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2455.92,
    y1: -4198.97,
    x2: -2449.46,
    y2: -4186.72,
    gradientTransform: "translate(-1961.95 -1137.47) rotate(146.27) scale(0.81)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2264.64,
    y1: -2510.37,
    x2: -2255.14,
    y2: -2513.04,
    gradientTransform: "translate(-2597.06 -1767.71) rotate(164.49) scale(1.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -2861.21,
    y1: 1220.09,
    x2: -2841.5,
    y2: 1222.49,
    gradientTransform: "translate(-177.71 -2107.88) rotate(-96.34) scale(0.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 59.28,
    y1: 2291.47,
    x2: 57.94,
    y2: 2304.38,
    gradientTransform: "translate(278.79 -898.76) rotate(-36.6) scale(0.89)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -3165.85,
    y1: -4790.39,
    x2: -3155.94,
    y2: -4790.39,
    gradientTransform: "translate(-1725.19 -1217.34) rotate(153.43) scale(0.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 959.35,
    y1: -1916.21,
    x2: 961.21,
    y2: -1906.05,
    gradientTransform: "matrix(0.5, 1.1, -1.1, 0.5, -1348.53, 602.37)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1603.88,
    y1: 911.89,
    x2: 1693.75,
    y2: 912.9,
    gradientTransform: "translate(2749.76 -403.36) rotate(113.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1262.01,
    y1: 566.9,
    x2: 1348.06,
    y2: 589.35,
    gradientTransform: "translate(765.46 2022.16) rotate(-95.83)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1438.44,
    y1: 732.37,
    x2: 1480.44,
    y2: 732.37,
    gradientTransform: "translate(211.44 -320.63) rotate(13.51)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1246.67,
    y1: 447.8,
    x2: 1279.18,
    y2: 447.8,
    gradientTransform: "translate(823.85 -553.05) rotate(47.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f9a71e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f26a3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2673d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rectangle_background",
    "data-name": "rectangle background"
  }, /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M348.47,674l18.75-.2,18.74-.13,18.74-.1,18.75,0L423,674q0-15.84,0-31.68l.47.47-18.75,0L386,642.7l-18.74-.14-18.75-.2,18.75-.2L386,642l18.74-.09,18.75,0h.46v.47q0,15.84,0,31.68v.47h-.46l-18.75,0L386,674.38l-18.74-.14Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M282.31,551.64l18.75-.2,18.74-.13,18.74-.1,18.75,0-.47.47q0-15.84,0-31.68l.47.47-18.75,0-18.74-.09-18.74-.14-18.75-.2,18.75-.2,18.74-.14,18.74-.09,18.75,0h.46V520q0,15.84,0,31.68v.47h-.46l-18.75,0L319.8,552l-18.74-.14Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1499.27,778.79l-37.6.28-18.7.11-18.67.05.44-.44.06,31.68-.5-.5,37.48.06,37.49.17-.27.27Zm0,0,.27,31.68v.27h-.28l-37.49.17-37.48.06h-.5v-.5l0-31.68v-.45h.45l18.81.06,18.79.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1457.45,738.84l-37.61.28-18.7.11-18.67,0,.45-.44,0,31.68-.5-.5,37.49.06,37.49.17-.28.27Zm0,0,.27,31.68v.27h-.27L1420,771l-37.49.06h-.5v-.5l.06-31.68v-.45h.44l18.82.06,18.79.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1494.89,517.08l-18.75.2-18.74.13-18.74.1-18.75,0,.47-.47q0,15.84,0,31.68l-.47-.47,18.75,0,18.74.09,18.74.14,18.75.2-18.75.2-18.74.14-18.74.09-18.75,0h-.46v-.47q0-15.84,0-31.68v-.47h.46l18.75,0,18.74.09,18.74.14Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M639.41,629.44l-37.38.28-18.78.11-18.82,0H564v-.44l-.05-31.68v-.5h.5l37.49.06,37.48.16h.28v.28Zm0,0-.28-31.68.27.27-37.48.16-37.49.06.5-.49,0,31.68-.45-.45,18.67.06,18.7.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M559.15,629.44l-37.37.28-18.78.11-18.82,0h-.44v-.44l-.05-31.68v-.5h.5l37.49.06,37.48.16h.28v.28Zm0,0-.27-31.68.27.27-37.48.16-37.49.06.5-.49-.05,31.68-.45-.45,18.67.06,18.7.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1141.2,792l-18.75.2-18.74.13-18.74.1-18.75,0h-.46V792q0-15.84,0-31.69v-.47h.46l18.75,0,18.74.1,18.74.13,18.75.2-18.75.21-18.74.13-18.74.1-18.75,0,.47-.47q.06,15.84,0,31.69l-.47-.47,18.75,0,18.74.09,18.74.14Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M623,814.82l-37.37.27-18.78.12-18.82,0h-.45v-.44l0-31.69v-.5h.5l37.49.07,37.48.16h.28v.27Zm0,0-.27-31.69.27.28-37.48.16-37.49.06.5-.5-.06,31.69-.44-.45,18.67,0,18.7.12Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1194.78,514.37l-37.37.27-18.78.12-18.82,0h-.45v-.44l0-31.69v-.5h.5l37.49.07,37.48.16h.28v.27Zm0,0-.27-31.69.27.28-37.48.16-37.49.06.5-.5-.06,31.69-.44-.45,18.67.06,18.7.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1153,554.32l-37.37.27-18.79.12-18.81,0h-.45v-.44l0-31.69v-.5h.5l37.48.07,37.49.16h.28v.27Zm0,0-.27-31.69.27.28-37.49.16-37.48.06.49-.5,0,31.69-.44-.45,18.66,0,18.71.12Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1219.53,1009.22l-37.37.28-18.79.11-18.82.06h-.44v-.45l-.06-31.68V977h.5l37.49.06,37.49.17h.27v.27Zm0,0-.27-31.68.27.27L1182,978l-37.49.06.5-.5,0,31.68-.45-.45,18.67.06,18.71.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1261.23,1047.73l-37.38.28-18.78.11-18.82.06h-.44v-.45l0-31.68v-.5h.5l37.49.06,37.48.17h.28v.27Zm0,0-.28-31.68.27.27-37.48.16-37.49.07.5-.5,0,31.68-.45-.45,18.67.06,18.7.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1207.36,669.55l-18.75.2-18.74.13-18.74.1-18.75,0h-.46v-.46q0-15.84,0-31.69v-.47h.46l18.75,0,18.74.1,18.74.13,18.75.2-18.75.21-18.74.13-18.74.1-18.75,0,.47-.47q.06,15.84,0,31.69l-.47-.47,18.75,0,18.74.09,18.74.14Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M598.83,1024.69l-37.38.28-18.78.11-18.82.06h-.44v-.45l0-31.68v-.5h.5l37.49.06,37.49.17h.27V993Zm0,0L598.55,993l.28.27-37.49.16-37.49.07.5-.5-.05,31.68-.45-.45,18.67.06,18.7.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M518.57,1024.69l-37.37.28-18.78.11-18.82.06h-.44v-.45l0-31.68v-.5h.5l37.49.06,37.48.17h.28V993Zm0,0L518.3,993l.27.27-37.48.16-37.49.07.5-.5-.05,31.68-.45-.45,18.67.06,18.7.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-1",
    d: "M1061,792l-37.38.27-18.78.12-18.82,0h-.44V792l-.06-31.69v-.5h.5l37.49.07L1061,760h.27v.27Zm0,0-.28-31.69.28.28-37.49.16-37.49.06.5-.5L986.42,792l-.45-.45,18.67.06,18.7.11Z",
    transform: "translate(-282.31 -477.2)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "congrats-img-cls-1",
    cx: 562.75,
    cy: 644.78,
    rx: 373.81,
    ry: 52.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-2",
    x: 473.04,
    y: 562.4,
    width: 169.32,
    height: 45.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-2",
    x: 511,
    y: 332,
    width: 89.65,
    height: 38.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-3",
    x: 976.19,
    y: 1026.43,
    width: 14.35,
    height: 122.84,
    transform: "translate(-500.45 1451.38) rotate(-82.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-4",
    x: 976.19,
    y: 1026.43,
    width: 14.35,
    height: 122.84,
    transform: "translate(-500.45 1451.38) rotate(-82.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-3",
    x: 975.89,
    y: 1080.13,
    width: 21.32,
    height: 14.35,
    transform: "translate(-508.54 1437.56) rotate(-82.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "congrats-img-cls-3",
    points: "765.47 645.07 773.16 510.47 860.81 518.07 844.27 650.19 765.47 645.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "congrats-img-cls-5",
    points: "744.31 641.92 765.47 645.07 773.16 510.47 745.54 522.27 744.31 641.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "congrats-img-cls-3",
    points: "620.15 610.09 651.6 614.49 654.7 593.58 623.25 589.17 620.15 610.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-3",
    x: 637.17,
    y: 1080.68,
    width: 122.84,
    height: 14.35,
    transform: "translate(-411.94 -382.08) rotate(-7.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-4",
    x: 637.17,
    y: 1080.68,
    width: 122.84,
    height: 14.35,
    transform: "translate(-411.94 -382.08) rotate(-7.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-3",
    x: 688.22,
    y: 1076.65,
    width: 14.35,
    height: 21.32,
    transform: "translate(-425.39 -371.11) rotate(-7.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "congrats-img-cls-3",
    points: "351.86 645.07 344.16 510.47 256.51 518.07 273.05 650.19 351.86 645.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "congrats-img-cls-5",
    points: "373.01 641.92 351.86 645.07 344.16 510.47 371.79 522.27 373.01 641.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "congrats-img-cls-3",
    points: "497.18 610.09 465.73 614.49 462.63 593.58 494.08 589.17 497.18 610.09"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M992.53,917.1c.47.18,48.51,18.75,85.34-8.82,37.67-28.19,47.19-105.62,47.28-106.4l14.26,1.67c-.4,3.43-10.29,84.33-52.94,116.23-43.38,32.45-93.19,12-95.45,11.12a16,16,0,0,1-.9-5.94A16.33,16.33,0,0,1,992.53,917.1Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-4",
    d: "M992.53,917.1c.47.18,48.51,18.75,85.34-8.82,37.67-28.19,47.19-105.62,47.28-106.4l14.26,1.67c-.4,3.43-10.29,84.33-52.94,116.23-43.38,32.45-93.19,12-95.45,11.12a16,16,0,0,1-.9-5.94A16.33,16.33,0,0,1,992.53,917.1Z",
    transform: "translate(-282.31 -477.2)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M677.4,892.68a74.48,74.48,0,0,0-6,14.88c-1.58,6.91-.59,12-.24,15.6L684.84,908Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-4",
    d: "M677.4,892.68a74.48,74.48,0,0,0-6,14.88c-1.58,6.91-.59,12-.24,15.6L684.84,908Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M710.51,967.87c-.08-.65-21.91-4.93-21.91-4.93l-14.54-83.43,25.61-12Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-6",
    d: "M714.42,967.13c-.07-.66-25.82-4.19-25.82-4.19l-14.31-83.48,30.81-13Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M985.61,844.19S767,834.88,693.1,847.14c0,0,21.69,210.77,22.86,214.85,0,0,217.51-.58,251.5,0C967.46,1062,985.89,921.85,985.61,844.19Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-6",
    d: "M915.82,902.45S802.49,898,764.2,903.87c0,0,11.24,101.3,11.85,103.27,0,0,112.74-.28,130.37,0C906.42,1007.14,914.16,937.8,915.82,902.45Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-6",
    d: "M781.61,1007.69c-2.59,0-4.65,0-6.09,0,0,0-9.65-68.52-11.32-103.87a61.6,61.6,0,0,1,9-1.07Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M781.46,908.14a4.87,4.87,0,0,0,3.6,5.45,4.87,4.87,0,1,0,1.46-9.58A4.88,4.88,0,0,0,781.46,908.14Zm0,0a3.92,3.92,0,0,1,4.92-3.2,3.93,3.93,0,1,1-4,6.37A4,4,0,0,1,781.46,908.14Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M782.87,929.62a4.87,4.87,0,0,0,3.6,5.45,4.87,4.87,0,1,0,1.47-9.58A4.88,4.88,0,0,0,782.87,929.62Zm0,0a4.05,4.05,0,0,1,1.82-2.76,4,4,0,0,1,3.1-.44,3.94,3.94,0,1,1-4,6.38A4,4,0,0,1,782.87,929.62Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M783.47,951a4.87,4.87,0,0,0,3.6,5.45,4.87,4.87,0,0,0,4.91-7.86,4.85,4.85,0,0,0-8.51,2.41Zm0,0a3.92,3.92,0,0,1,4.92-3.2,3.93,3.93,0,1,1-4,6.37A4,4,0,0,1,783.47,951Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M785,997.66a4.87,4.87,0,0,0,3.6,5.45,4.87,4.87,0,1,0,1.47-9.58A4.88,4.88,0,0,0,785,997.66Zm0,0a4.05,4.05,0,0,1,1.82-2.76,4,4,0,0,1,3.1-.44,3.94,3.94,0,1,1-4,6.38A4,4,0,0,1,785,997.66Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M783.87,974.76a4.88,4.88,0,0,0,3.59,5.46,4.87,4.87,0,1,0,1.47-9.59A4.89,4.89,0,0,0,783.87,974.76Zm0,0a3.91,3.91,0,0,1,4.92-3.19,3.94,3.94,0,0,1-1.18,7.72,4,4,0,0,1-2.84-1.35A4.07,4.07,0,0,1,783.87,974.76Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "congrats-img-cls-7",
    points: "652.53 370.62 651.18 396.45 650.04 422.29 648.04 473.97 646.49 525.66 645.86 551.52 645.44 577.38 646.78 551.55 647.93 525.71 649.92 474.03 651.48 422.33 652.1 396.48 652.53 370.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M942.24,863.39a4.87,4.87,0,0,0,3.33,5.62,4.87,4.87,0,1,0,1.92-9.51A4.87,4.87,0,0,0,942.24,863.39Zm0,0a4,4,0,0,1,1.94-2.67,4,4,0,0,1,3.12-.29,3.94,3.94,0,0,1-1.54,7.66,3.9,3.9,0,0,1-3.52-4.7Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M938.2,952.59a4.85,4.85,0,0,0,7.16,5.18,4.86,4.86,0,0,0-1.91-9.07A4.89,4.89,0,0,0,938.2,952.59Zm0,0a3.91,3.91,0,0,1,5.07-3A3.93,3.93,0,1,1,939,955.8,4,4,0,0,1,938.2,952.59Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M936,1025.86a4.87,4.87,0,0,0,3.33,5.61,4.87,4.87,0,1,0,1.92-9.5A4.87,4.87,0,0,0,936,1025.86Zm0,0a3.91,3.91,0,1,1,7.66,1.54,3.94,3.94,0,0,1-4.14,3.16,3.92,3.92,0,0,1-3.52-4.7Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M968.2,967c0-.65,25.72-4.75,25.72-4.75l12.46-83.78-31.09-12.28Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-6",
    d: "M968.2,967c0-.65,25.72-4.75,25.72-4.75l12.46-83.78-31.09-12.28Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M1004.68,758.18c0-1,32-11.73,32-11.73l5-127.53-41-12.79Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-6",
    d: "M1004.68,758.18c0-1,32-11.73,32-11.73l5-127.53-41-12.79Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M667.26,789.18C667,788.22,635,785,635,785L599.24,662.52l34.57-21.66Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-6",
    d: "M667.26,789.18C667,788.22,635,785,635,785L599.24,662.52l34.57-21.66Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M1011.52,805.6s-2.66-206.83-11.07-275.27c0,0-250,5.42-387.13,49.56,0,0,56.33,244.45,59.27,256.59C672.59,836.48,849.76,811.38,1011.52,805.6Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "congrats-img-cls-6",
    cx: 923.29,
    cy: 697.31,
    r: 70.8,
    transform: "translate(-504.96 379.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "congrats-img-cls-2",
    cx: 923.29,
    cy: 697.31,
    r: 56.78,
    transform: "translate(-450.29 -164.4) rotate(-17.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-8",
    x: 899.13,
    y: 670.96,
    width: 55.78,
    height: 55.78,
    transform: "translate(1640.95 817.66) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-2",
    x: 925.91,
    y: 694.72,
    width: 27.42,
    height: 27.42,
    transform: "translate(1667.12 835.43) rotate(173.88)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "congrats-img-cls-2",
    cx: 731.99,
    cy: 716.73,
    r: 56.78,
    transform: "translate(-513.93 587.32) rotate(-64.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-8",
    x: 705.81,
    y: 691.48,
    width: 55.78,
    height: 55.78,
    transform: "translate(1325.17 782.81) rotate(167.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "congrats-img-cls-2",
    x: 734.24,
    y: 713.62,
    width: 27.14,
    height: 27.14,
    transform: "translate(1354.77 795.17) rotate(167.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M802.56,547.28q4.07,37.54,8.38,75.06l8.83,75,.75-1-.75,1h0l1.07.79h0l.86-.15-.11-.86-9.29-75Q807.61,584.71,802.56,547.28Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M811,577a4.87,4.87,0,0,0,4.11,5.07,4.87,4.87,0,1,0,.53-9.68A4.89,4.89,0,0,0,811,577Zm0,0a3.91,3.91,0,0,1,4.58-3.67,3.94,3.94,0,0,1-.42,7.81A3.91,3.91,0,0,1,811,577Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M817.31,625.5a4.89,4.89,0,0,0,4.11,5.08,4.87,4.87,0,1,0,.53-9.69A4.9,4.9,0,0,0,817.31,625.5Zm0,0a4,4,0,0,1,1.54-2.92,4,4,0,0,1,3-.74,3.94,3.94,0,0,1-.42,7.8,3.9,3.9,0,0,1-4.17-4.14Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-7",
    d: "M824.59,675.84a4.87,4.87,0,0,0,4.11,5.07,4.87,4.87,0,1,0,.53-9.68A4.89,4.89,0,0,0,824.59,675.84Zm0,0a3.91,3.91,0,0,1,4.58-3.67,3.94,3.94,0,0,1-.42,7.81,3.91,3.91,0,0,1-4.16-4.14Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-9",
    d: "M812.54,773.83a21,21,0,0,0,40.55-6",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "congrats-img-cls-10",
    points: "713.7 62.68 664.9 66.98 664.88 64.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "congrats-img-cls-10",
    points: "616.17 68.07 665.15 66.91 664.94 64.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "congrats-img-cls-10",
    points: "520.07 368.02 471.08 368.54 471.27 370.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "congrats-img-cls-10",
    points: "422.48 372.25 471.34 368.59 471.33 370.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-10",
    d: "M639.33,672.1c-2.05-7.31-3.84-14.67-5.76-22s-3.64-14.71-5.36-22.08-3.43-14.76-5.11-22.14-3.24-14.79-4.88-22.19l-.43-2,2-.58q23.55-7,47.32-13,11.9-3,23.87-5.73c8-1.69,16-3.47,24.07-4.85l-47,14-47,13.83,1.51-2.55c1.53,7.41,3.14,14.81,4.6,22.24s3,14.85,4.38,22.3,2.79,14.89,4.12,22.34S638.21,664.59,639.33,672.1Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-10",
    d: "M986.06,686.17a61.71,61.71,0,0,0-10-25.84c-1.28-2-2.77-3.79-4.19-5.67s-3.16-3.49-4.76-5.23c-1.76-1.58-3.53-3.15-5.34-4.68-1.93-1.36-3.83-2.78-5.8-4.1-2.09-1.13-4.16-2.3-6.26-3.38l-6.61-2.66-6.88-1.79c-2.31-.46-4.68-.65-7-.94a68.21,68.21,0,0,0-27.49,3.84c9.15-1.24,18.23-1.73,27.09-.43a63.73,63.73,0,0,1,24.84,9.1,73.83,73.83,0,0,1,19.63,17.94A83.56,83.56,0,0,1,986.06,686.17Z",
    transform: "translate(-282.31 -477.2)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M679.32,911.16c.1.49,14.88,54.72,58,68.75,44.75,14.54,114.29-18,115-18.31l6.37,12.86c-3.1,1.53-76.33,37.31-126.31,18.92-50.85-18.7-60.77-67.83-61.24-70.22C672,922.06,677.77,911.2,679.32,911.16Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-4",
    d: "M679.32,911.16c.1.49,14.88,54.72,58,68.75,44.75,14.54,114.29-18,115-18.31l6.37,12.86c-3.1,1.53-76.33,37.31-126.31,18.92-50.85-18.7-60.77-67.83-61.24-70.22C672,922.06,677.77,911.2,679.32,911.16Z",
    transform: "translate(-282.31 -477.2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-11",
    d: "M1110.08,841.43c.92,3.81-2.3,7.46-5.65,8.8-5,2-10.89.36-15.84-1.11-5.44-1.62-11.07-3.42-16.82-2.7a25.53,25.53,0,0,0-13,5.82c-8.06,6.53-11.91,16.42-14.8,26.07-2.8,9.39-5,19.5-11.3,27.33a25.33,25.33,0,0,1-10,7.77,29.11,29.11,0,0,1-10.8,2c-8.11.08-16.05-2-23.93-3.72s-16.07-3.33-24.14-2.27a31,31,0,0,0-11.72,3.88,35.06,35.06,0,0,0-10.49,10.06c-5.87,8.22-8.76,18-13.7,26.77-4.39,7.74-11.48,15.35-21,15.58a15,15,0,0,1-6.12-1.17,2.52,2.52,0,0,0-3.07,1.75,2.56,2.56,0,0,0,1.75,3.07c9.24,3.78,19.9-.84,26.35-7.74,7.29-7.79,10.55-18.07,15.24-27.42,4-8.09,9.61-16,18.59-18.79,7.46-2.33,15.56-1.21,23.17.3,16,3.18,34.65,9.5,48.9-1.92,8-6.39,11.91-16.4,14.77-25.9,3-9.93,5.24-20.8,12.39-28.74a23.58,23.58,0,0,1,10.77-7.21c5.42-1.56,10.86,0,16.09,1.53,5.59,1.67,11.33,3.31,17.2,2.34a15,15,0,0,0,11.44-8.66,11.06,11.06,0,0,0,.6-7c-.75-3.13-5.58-1.81-4.82,1.33Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-12",
    d: "M1236.05,767.5l-32.65-28.64-.28-.25L1170.47,710l-70.1,114.49s0,0-.06.06c-2.37,2.69,2.73,11,11.38,18.63s17.6,11.57,20,8.87c.06-.07.09-.15.14-.22Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-13",
    d: "M1154.44,795.67c-10.54-5.66-19.25-12.22-25.14-18.46l-4.42,7.22c5.89,6.14,14.51,12.58,24.87,18.14a107.5,107.5,0,0,0,29.35,11l7.88-6.38C1177.68,805.85,1166.09,801.92,1154.44,795.67Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-13",
    d: "M1138.71,812.47a107.9,107.9,0,0,1-21.75-15.1l-4.4,7.18A108.81,108.81,0,0,0,1134,819.38a113,113,0,0,0,25.38,10.09l7.7-6.22A109,109,0,0,1,1138.71,812.47Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-13",
    d: "M1104.79,817.25l-4.39,7.16a114.32,114.32,0,0,0,17.89,11.77,117.51,117.51,0,0,0,21.61,9.06l7.55-6.1a119.92,119.92,0,0,1-42.66-21.89Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-13",
    d: "M1185.91,762.06c-15.18-8.15-26.61-18.16-31.17-26.4l-4.48,7.32c4.72,8.16,16,18,31,26,14.14,7.59,28.21,11.78,38.18,12l8.75-7.08C1218.21,775,1202.11,770.76,1185.91,762.06Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-13",
    d: "M1170.18,778.86c-12.65-6.78-22.69-14.87-28.33-22.14l-4.44,7.25c5.69,7.18,15.63,15.12,28.07,21.8,12.08,6.48,24.1,10.49,33.56,11.65l8.17-6.6C1197.33,790.32,1183.79,786.17,1170.18,778.86Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-11",
    d: "M1237.09,766.9c-5,5.66-23.78-2.73-42-18.74s-29-33.57-24-39.23,23.78,2.73,42,18.73S1242.05,761.24,1237.09,766.9Z",
    transform: "translate(-282.31 -477.2)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-14",
    d: "M903.51,973.06l-50.59,13.62L841,942.39a94.77,94.77,0,0,0,50.59-13.61Q897.54,950.92,903.51,973.06Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M904.52,976.89a63,63,0,0,1-50.59,13.62l-11.1-41.21a71.39,71.39,0,0,0,50.6-13.62Q899,956.29,904.52,976.89Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-15",
    d: "M1368,601.67a35.44,35.44,0,0,0,2.61,12.13,14.31,14.31,0,0,0,6-4.61c-1.5-2.18-1.7-4.22-1.73-7.41A8,8,0,0,1,1368,601.67Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-16",
    d: "M1374.73,482.56c2.08,2.18,2.87,4,2.36,7.61,3.75-1.28,5.92-3,9.66-6.39.3-2.81-.42-4.25-2.63-6.58C1380.89,480.07,1378.37,481.91,1374.73,482.56Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-17",
    d: "M1308.68,658.51c2.85-5.14,3.82-8.27,2.44-14.43a106.06,106.06,0,0,1-23.33-9.32,15.7,15.7,0,0,1-2.78,7.59C1294.93,647.13,1300.4,651.33,1308.68,658.51Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-18",
    d: "M1415.08,713.31a14.34,14.34,0,0,0,7-2.91c-.88-2.51-.53-4.56.28-7.67a8.1,8.1,0,0,1-6.65-1.93",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-19",
    d: "M1434.75,594.07a31.25,31.25,0,0,1,5.16,12.17c8.41-6.88,14.39-11,21.91-14.5.2-5.7-1.17-8.57-3.68-12.22C1452.54,581.77,1443.9,587.08,1434.75,594.07Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-20",
    d: "M1539,519.34c4.82-2,7.38-3.91,10.84-8.69-5.59-3.33-8.21-6.31-10.21-10.4-4.66,1.49-7.53,3.28-11.64,6.56C1532.71,510.4,1535.42,513.74,1539,519.34Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-21",
    d: "M1593.44,612.35c-2-2.44-4.36-3.08-8.3-4-1.68,8.67-6.06,17.38-12.07,27,3.13.9,4.85,2.22,7.2,4.93C1587.24,630.47,1590.28,624.39,1593.44,612.35Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-22",
    d: "M1262.27,565.91a18.77,18.77,0,0,1-5.63-5.67c-3.18,5.76-5.6,9.45-9.05,13.07a10.63,10.63,0,0,0,4.81,6C1255.05,576.82,1258.7,571.9,1262.27,565.91Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-23",
    d: "M1569.7,572.88c-3.67-.62-7.72-1-11.58.93a27.08,27.08,0,0,1-4.23,7.25c2.76-.2,4.27,1,6.55,4.16C1562.39,580.88,1565.48,577.47,1569.7,572.88Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-24",
    d: "M1364.17,755.11a47.31,47.31,0,0,1-9.4-16c-3.36,1.2-6,2.82-7.91,5.56,1.27,4.75,4.1,10.14,8.57,17C1358,757.14,1360.06,755.22,1364.17,755.11Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-25",
    d: "M1303.42,525.68c3.61-1.58,7.87-1.68,16.86,1.61.78-4.07.34-7.81-1.72-12.56-7-1.53-11.34-1.86-18.13-.28C1302.79,518,1303.23,520.61,1303.42,525.68Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-26",
    d: "M1538.61,718.24c2.48,2.36,3.48,4.42,3.09,8.5,4.19-1.65,6.55-3.72,10.61-7.76.19-3.2-.7-4.8-3.33-7.32C1545.47,715.09,1542.71,717.3,1538.61,718.24Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-27",
    d: "M1482.76,636.75c-.81-3.45-1.8-6.13-3.82-8.28a8.35,8.35,0,0,0-5,2.4,15.61,15.61,0,0,1,3.69,8.19C1479.37,637.32,1480.63,636.57,1482.76,636.75Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-28",
    d: "M1237.58,694.06a9.11,9.11,0,0,1-6.59,3.73c3.36,7.44,6.43,11.74,11.33,17.8a17.44,17.44,0,0,0,8.19-4.45C1244,706,1241.14,701.41,1237.58,694.06Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "congrats-img-cls-29",
    x1: 535.1,
    y1: 616.96,
    x2: 535.1,
    y2: 328.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-30",
    d: "M1228.16,748.91l-.26-.12a12,12,0,0,1-4.22-3.56c10.48-.77,23.71-14.12,37.22-14.56l9.6,4.5C1254.69,735.69,1239.26,753.88,1228.16,748.91Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-31",
    d: "M1217.81,656l.14,0a7.69,7.69,0,0,1,4.57,1.12c-16.32,11-11.64,46.06-25.76,53.76a11.29,11.29,0,0,1-4.18,1.28,12.62,12.62,0,0,1-5-.54c14.22-8.5,8.78-45.61,27.56-54.79A7.58,7.58,0,0,1,1217.81,656Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-32",
    d: "M1484.6,717.55l-3.08,12.8c-1.43,5.95-6.4,11.08-12.8,14.59a41.62,41.62,0,0,1-10.47,4c-6.94,1.62-14.19,1.43-19.89-1.24-2.66-1.25-3.63-2.41-3.4-3.32l3.07-12.79c-.22.91.76,2.08,3.4,3.31,5.71,2.68,13,2.87,19.9,1.24,8.23-1.92,16-6.41,20.29-12.32A17.81,17.81,0,0,0,1484.6,717.55Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-33",
    d: "M1392,663l-11.87,10.91-1.09,1c-7.32,6.07-22.25,6.92-37.72,9.1-11,1.54-18.8,3.66-24.44,6.23a29.63,29.63,0,0,0-7.57,4.76l12.46-11.49c5.36-4.75,14.9-8.53,32-10.93,10.87-1.54,21.48-2.41,29.36-4.91A23.41,23.41,0,0,0,1392,663Z",
    transform: "translate(-282.31 -477.2)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-3",
    d: "M1136.87,828.26l23.79-21.33a20.87,20.87,0,0,0,9,9.84,21.09,21.09,0,0,0,15.58,1.64l-23.78,23.79a21,21,0,0,1-12.3-.82C1140.38,838,1137.33,829.58,1136.87,828.26Z",
    transform: "translate(-282.31 -477.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "congrats-img-cls-14",
    d: "M1160.66,806.93l6.56-4.1a11.48,11.48,0,0,0,4.92,7.38,11.62,11.62,0,0,0,9.54,1.23c1.19,2.33,2.39,4.65,3.58,7a21.09,21.09,0,0,1-15.58-1.64A20.87,20.87,0,0,1,1160.66,806.93Z",
    transform: "translate(-282.31 -477.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratsAssistantRobot);
export default __webpack_public_path__ + "static/media/congrats-assistant-robot.ece708c0530ec2ae82823966f5adfb59.svg";
export { ForwardRef as ReactComponent };